export default {
    allConfigurations: null,
    isFreePreviewEnabled: 0,
    showHeaderAlert: false,
    daysLeft: 0,
    enableLiveStreaming: false,
    liveStreamingURL: '',
    totalTrialDays: 0,
    cardExpiryDays: 50,
    pressReleaseData: null,
    messageDuration: 0,
    messageBoard: null,
    CorpLiveStreamingURL: '',
    allArticles: null,
    selectedArticle: null,
    defEventSwitch: 0,
    enableCorporateLiveStreaming: false,
    faqs: null,
    members: null,
    isMaintenance: false,
    giftingText: 'Give the gift of TONE',
    showCustomUnauthBanner: false,
    unauthBannerText: '',
    unauthBannerLink: '',
    turnOffGifting: false,
    paidMembershipService: false,
    profileCharitySection: true,
    authLeftTopBannerMessage: '',
    authLeftTopBannerUrl: '',
    unauthFindMoreUrl: '',
    showEventParticipantCount: false,
    advisoryBoard: null
}



// WEBPACK FOOTER //
// ./src/store/configuration/state.js